import { Eye } from "lucide-react";

export const RoleBriefing = ({ role }) => (
  <div className="bg-white border border-slate-200/80 rounded-xl p-6 shadow-sm shadow-slate-100 border-l-4 border-l-teal-500" data-testid="role-briefing">
    <div className="flex items-center gap-2 mb-2">
      <Eye className="w-4 h-4 text-teal-600" />
      <p className="font-mono text-[10px] uppercase tracking-widest text-slate-500">Briefing for {role.label}</p>
    </div>
    <p className="text-sm text-slate-700 leading-relaxed">{role.briefing}</p>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-4">
      {role.watch.map((w, i) => (
        <div key={i} className="bg-slate-50 border border-slate-200/80 rounded-lg p-3">
          <p className="font-mono text-[10px] uppercase tracking-widest text-teal-700 mb-1">Watch {i + 1}</p>
          <p className="text-xs text-slate-600 leading-snug">{w}</p>
        </div>
      ))}
    </div>
  </div>
);
